import { z } from 'zod';

const DamTypeDef = [
    'On-Stream',
    'Off-Stream',
    'Gully',
    'Hillside',
    'Excavated Tank',
    'Ring Tank',
    "Turkey's Nest",
] as const;

export const allDamTypes = [...DamTypeDef];

export type DamType = (typeof DamTypeDef)[number];

export const damTypeSchema = z.enum(DamTypeDef);
